import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { Scorecard } from '../scorecard-next.model';
import { GridData } from '../scorecard.model';

import { CompensationBonusData } from './compensation-bonus-data.model';
import { OverallScoreData } from './overall-score-data.model';
import { WidgetType } from './template-definition.model';
import { YourTeamData } from './yourteam-data.model';

/** because of the way the widget views are created,
 * after 5 mins of thought this seems to be a non convoluted way to trigger scorecard data changes */
@Injectable()
export class ScorecardDataService {
    private readonly _widgetDataObservables: Map<
        WidgetType,
        BehaviorSubject<any>
    >;

    constructor() {
        this._widgetDataObservables = new Map();
        [
            WidgetType.SCORECARD_GRID,
            WidgetType.FYI_GRID,
            WidgetType.OVERALL_SCORE_GRID,
            WidgetType.RANKINGS_GRID,
            WidgetType.COMPENSATION_CONDITION,
            WidgetType.COMPENSATION_MODIFIERS,
            WidgetType.COMPENSATION_QUALIFIERS,
            WidgetType.COMPENSATION_BONUS,
            WidgetType.METRIC_TREND_CHART,
            WidgetType.YOUR_TEAM,
        ].forEach((e) => {
            this._widgetDataObservables.set(e, new BehaviorSubject(null));
        });
    }

    observableForWidgetType<T>(widgetType: WidgetType): Observable<T> {
        return this._widgetDataObservables.get(widgetType).asObservable();
    }

    /** only scorecard.component should be calling this */
    changeScorecardData(scorecard: Scorecard): void {
        this._widgetDataObservables.forEach((value, key) => {
            switch (key) {
                case WidgetType.SCORECARD_GRID:
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value.next({
                        tplConfig: scorecard.data.templateConfig,
                        header: scorecard.header,
                        data: scorecard.data.pillarsAndMetrics,
                        attributes: scorecard.data.scorecardAttributes,
                        directReportContributionGrid:
                            scorecard.data.directReportContributionMetrics,
                        directReportScorecardGrid:
                            scorecard.data.directReportScorecardsMetrics,
                        directReportRankGrid:
                            scorecard.data.directReportScorecardsRank,
                    } as GridData);
                    break;
                case WidgetType.FYI_GRID:
                    value.next(scorecard.data.fyiMetrics);
                    break;
                case WidgetType.OVERALL_SCORE_GRID:
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value.next({
                        scores: scorecard.data.overallScores,
                        header: scorecard.header,
                    } as OverallScoreData);
                    break;
                case WidgetType.RANKINGS_GRID:
                    value.next(scorecard.data.ranks);
                    break;
                case WidgetType.COMPENSATION_CONDITION:
                    value.next(scorecard.data.compensationConditions);
                    break;
                case WidgetType.COMPENSATION_QUALIFIERS:
                    value.next(scorecard.data.compensationQualifiers);
                    break;
                case WidgetType.COMPENSATION_MODIFIERS:
                    value.next(scorecard.data.compensationModifiers);
                    break;
                case WidgetType.COMPENSATION_BONUS:
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value.next({
                        compensationBonus: scorecard.data.compensationBonus,
                        compensationBaseBonus:
                            scorecard.data.compensationBaseBonus,
                    } as CompensationBonusData);
                    break;
                case WidgetType.METRIC_TREND_CHART:
                    break;
                case WidgetType.YOUR_TEAM:
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value.next({
                        roster: scorecard.data.roster,
                        periodTypeId: scorecard.header.periodType,
                    } as YourTeamData);
                    break;
            }
        });
    }
}
